import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  // getCustomerList,
  getEmployeeList,
  workflow,
} from "../../../../redux/feature/customer_app/customerSlice";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import { formatDate, formatDateWithAMPM, getContactDetails } from "../../../../common/Validations";
import { SearchField } from "../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../Components/ConfirmationLoader";
import BroadcastModel from "../../../../Components/Modal/supplier_app/BroadcastModel";
import CreateCustomerMasterModal from "../../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
// import { formatDateTime } from "../../../../common/Validations";
// import { hasAccess } from "../../../../utils/roleUtils";
import CommonFilterCustomerV2 from "../Common/CommonFilterCustomerV2";
// import ChatBox from "../../../../Components/ChatBox/ChatBox";
import CustomerConstants from "../../../../common/CustomerConstants";
import StickyColumn from "../../../../Components/Sticky/StickyColumn";
import CustomerV2DeactivateModel from "../Common/CustomerV2DeactivateModel";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
// import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

const EmployeeList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Employee");
  localStorage.setItem("submenu", "Employee Master");
  let customerData = useSelector((state) => state?.customer?.employee); // User Details from Store
  let customerTable = useSelector((state) => state?.customer.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  //Page Config
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig); // Config Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  // eslint-disable-next-line
  const [pageConfigInfo, setPageConfigInfo] = useState(null);
  // eslint-disable-next-line
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, userData]);

  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [totalRows, setTotalRows] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const [getFilter, setFilter] = useState({});
  const [selectedRole, setSelectedRole] = useState("C05"); // default Driver

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  // Chat Implementation
  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      // console.log("obj", obj);
      await ItemService.supplierDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = (customerID) => {
    dispatch(addcustomerID(customerID));
    navigate(Constants.CUSTOMER_V2_REGISTER_DETAIL);
  };
  //required in feature
  // const navigateConvertKYC = (customerID) => {
  //   dispatch(addcustomerID(customerID));
  //   navigate(Constants.CUSTOMER_V1_KYC_REGISTRATION_FORM);
  // };

  //required in feature
  // const navigateCostingSheet = (customerID) => {
  //   dispatch(addcustomerID(customerID));
  //   navigate(Constants.CUSTOMER_V1_COSTING_SHEET);
  // };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  // OnClick on Certificate document Data
  const certificateDocumentShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };
  const jobRoleData = [
    { id: 1, code: "C05", name: "Driver", description: "Drive desc" },
    { id: 2, code: "C06", name: "Employee", description: "Employe desc" },
    { id: 3, code: "C07", name: "Office Boy", description: "office desc" },
    { id: 4, code: "C08", name: "Sales", description: "sales desc" },
    { id: 5, code: "C09", name: "Others", description: "other desc" },
  ];

  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getCustomersByCustomerTypeCode",
        customerTypeCode: selectedRole,
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getCustomersByCustomerTypeCode",
        customerTypeCode: selectedRole,
        page: page,
        per_page: getNewPerPage,
      };
    }
    // let obj = {
    //   queryName: "getEmployeeList",
    //   module: "CUSTOMER_KYC",
    //   page: page,
    //   per_page: getNewPerPage,
    // };
    dispatch(getEmployeeList(obj));
    // setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getCustomersByCustomerTypeCode",
        customerTypeCode: selectedRole,
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getCustomersByCustomerTypeCode",
        customerTypeCode: selectedRole,
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getEmployeeList(obj));
    // setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCustomersByCustomerTypeCode",
      customerTypeCode: selectedRole,
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getEmployeeList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    // loadInitialSuuplierData(); // fetch page 1 of users
    // dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);
  useEffect(() => {
    if (customerData?.data) {
      setData(customerData.data);
    }
  }, [customerData]);
  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "getCustomersByCustomerTypeCode",
      customerTypeCode: selectedRole,
      page: 1,
      per_page: 10,
    };
    dispatch(getEmployeeList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRole]);
  // useEffect(() => {
  //   console.log("Redux customerData ===>", customerData);
  //   if (customerData?.data) {
  //     setData(customerData.data);
  //   }
  // }, [customerData]);

  const columns = [
    {
      name: "ID",
      id: "userId",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.userId)}>
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Employee Name",
      id: "organisationName",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold text-primary">
            {/* {row.employeeName} */}
            {row.organisationName}
          </span>
        </>
      ),
      selector: (row) => row.organisationName,
      sortable: true,
      width: "150px",
    },

    {
      name: "Address",
      selector: (row) => row.address || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.address} </p>
          <p className="m-0 p-0 fw-bold">{row.address2} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },

    /*  {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    }, */
    {
      name: "Documents",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => certificateDocumentShowModal(row.certifications)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">{row.certifications?.length}</span>
        </>
      ),
      width: "130px",
    },
    {
      name: "Status",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },
    // {
    //   name: "Employee Name",
    //   cell: (row) => (
    //     <>
    //       <span>{row?.employeeName}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.contactfirstName || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Contact Person",
    //   cell: (row) => (
    //     <>
    //       <span>{getContactDetails(row)?.contactName}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.contactfirstName || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    // {
    //   name: "Contact Number",
    //   cell: (row) => (
    //     <>
    //       <span>{getContactDetails(row)?.contactNumber}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.contactNumber,
    //   sortable: true,
    //   width: "150px",
    // },
    {
      name: "Contact Number/Email",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">
              {getContactDetails(row)?.contactNumber}
            </p>
            <p className="m-0 p-0">{getContactDetails(row)?.contactEmail}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    /* {
      name: "Contact Email",
      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactEmail}</span>
        </>
      ),
      // selector: (row) => row.email,
      sortable: true,
      width: "220px",
    }, */
    /*    {
      name: "Deactivate Remark",
      cell: (row) => (
        <>
          <span>{row?.remark}</span>
        </>
      ),
      // selector: (row) => row.email,
      sortable: true,
      width: "220px",
    }, */
    {
      name: "Created Date",
      // selector: (row) => formatDateTime(row.createdAt),
      selector: (row) => formatDateWithAMPM(row.createdAt),
      sortable: true,
      width: "200px",
    },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];

  const certificateDocumentColInfo = [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Issuing  Date",
      cell: (row) => <span>{formatDate(row.issueDate)} </span>,
      width: "180px",
    },
    {
      name: "Certificate Attachment",
      cell: (row) => (
        <div className="d-flex justify-content-center">
          {row.iSOCertification ? (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() => handleViewFile(row.iSOCertification)}
            />
          ) : (
            "--"
          )}
        </div>
      ),
      width: "180px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  /* Modal Function */
  /* required  */
  // const showStatusInfo = (rowData) => {
  //   setModalShowStatus(true);
  //   setSendDataModal(rowData);
  //   setModelTitle("Status Information");
  // };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };

  const handleEmployeeRegister = () => {
    navigate(CustomerConstants.CUSTOMER_V2_EMP_REGISTRATION);
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomersByCustomerTypeCode",
      customerTypeCode: selectedRole,
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getEmployeeList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Employee List</h2>
                <p className="subText">Employee Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />
            <Col xs={12} md={4} lg={3} className="mb-3">
              <label className="form-label">Position/Job Role</label>
              <select
                className="form-select"
                style={{ width: "100%" }}
                value={selectedRole}
                onChange={(e) => setSelectedRole(e.target.value)}
              >
                {/* Optional placeholder */}
                {jobRoleData.map((role) => (
                  <option key={role.id} value={role.code}>
                    {role.name}
                  </option>
                ))}
              </select>
            </Col>

            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">EL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Employee List</span>
                      <span className="subHeaderTitle">
                        View of Employee and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={handleEmployeeRegister}
                        >
                          <i className="bi bi-person-plus"></i> Add Employee
                        </button>
                      </Col>

                      {/* {hasAccess(
                        userRole,
                        "buttons",
                        "customer_list_add_deactivate",
                        pageConfigInfo
                      ) &&
                        config?.deactivateListBtn && (
                          <Col
                            xs={4}
                            md={2}
                            lg={2}
                            className="btnSpaceInMobile"
                          >
                            <button
                              className="btnTable"
                              onClick={() =>
                                setShowSupplierDeactivateModel(true)
                              }
                            >
                              Deactivate List
                            </button>
                          </Col>
                        )} */}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn columnIndexes={[2]} leftOffsets={[0, 40]} />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <CustomerV2DeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      {/* {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )} */}
    </main>
  );
};

export default EmployeeList;
